// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"81":"DataList","265":"Player","442":"ReportPreview","819":"Compare"}[chunkId] + "." + {"81":"dcb8c11a","265":"ef95a253","442":"223dbc57","819":"ef95a253"}[chunkId] + ".chunk.css";
};